import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * One options row of the download dialog: a 120px section label on the left,
 * the controls on the right (UI Design Standards §4.4 options layout).
 *
 * labelOffset: top padding that lines the label up with the first control.
 */
const ExportSectionRow = ({ label, labelOffset = 0, alignCenter = false, children }) => {
  const { ft } = useTheme().palette;
  return (
    <Box
      role="group"
      aria-label={label}
      sx={{
        display: 'grid',
        gridTemplateColumns: '120px minmax(0, 1fr)',
        columnGap: 2,
        alignItems: alignCenter ? 'center' : 'start',
      }}
    >
      <Typography
        variant="sectionLabel"
        component="div"
        sx={{ color: ft.neutrals.textSecondary, pt: alignCenter ? 0 : `${labelOffset}px` }}
      >
        {label}
      </Typography>
      <Box sx={{ minWidth: 0 }}>{children}</Box>
    </Box>
  );
};

export default ExportSectionRow;
